
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/astro/kundali",
      function () {
        return require("private-next-pages/astro/kundali/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/astro/kundali"])
      });
    }
  